import { T, useGT } from 'gt-react';
import { PlusIcon, TrashIcon } from '@phosphor-icons/react';
import { Button } from 'src/components/ui/button';
import { Input } from 'src/components/ui/input';
import { useOutcomeEditorRows } from './useOutcomeEditorRows';

const EMPTY_OPTIONS: string[] = [];

export function TaskOutcomeOptionsEditor({
  options,
  onChange,
}: {
  options: string[] | undefined;
  onChange: (options: string[]) => void;
}) {
  const gt = useGT();
  const editor = useOutcomeEditorRows(options ?? EMPTY_OPTIONS, onChange);
  return (
    <div className="flex flex-col gap-2">
      {editor.rows.map(({ id, value }) => (
        <div key={id} className="flex gap-2">
          <Input
            aria-label={gt('Option value', {
              context: 'outcome select option input',
            })}
            value={value}
            onChange={(event) => editor.update(id, event.target.value)}
          />
          <Button
            type="button"
            variant="ghost"
            onClick={() => editor.remove(id)}
          >
            <TrashIcon />
            <T context="remove outcome select option">Remove</T>
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" onClick={() => editor.add('')}>
        <PlusIcon />
        <T context="add outcome select option">Add Option</T>
      </Button>
    </div>
  );
}
